export const apiHost = "https://api.bellefonte.com";
export const baseUrl = "https://api.bellefonte.com";
///export const apiHost = "https://destinations.3twenty9.net";
///export const baseUrl = "https://destinations.3twenty9.net";
///export const apiHost = "https://happyvalley-api.test";
///export const baseUrl = "https://happyvalley-api.test";
export const recaptchaKey = "6LdhZHwpAAAAADKjDSsePr4h0vNyt3pKmc23ttB-";